import hammerjs from 'hammerjs';
import { enhancePointerEventInput, enhanceMouseInput } from './hammer-overrides';
enhancePointerEventInput(hammerjs.PointerEventInput);
enhanceMouseInput(hammerjs.MouseInput);
export var Manager = hammerjs.Manager;
export default hammerjs;


//////////////////
// WEBPACK FOOTER
// ./~/mjolnir.js/dist/esm/utils/hammer.browser.js
// module id = 665
// module chunks = 0